import type { Locale } from '@porotutu/i18n'
import { ExportMenu } from '@porotutu/react/components/ExportMenu/ExportMenu'
import { EXPORT_SCOPES } from '../../vocabulary'
import { type AuditListQuery, exportHref } from '../queries'

export type AuditExportProps = { query: AuditListQuery; locale: Locale }

export function AuditExport({ query, locale }: AuditExportProps) {
  return (
    <ExportMenu
      scope="adm.audit.export"
      scopes={EXPORT_SCOPES}
      href={(scope, format) => exportHref(query, scope, format, locale)}
    />
  )
}
